import { Component } from "react";
import { Sparkles, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("ErrorBoundary caught an error:", error, info?.componentStack);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
    if (typeof window !== "undefined") {
      window.location.reload();
    }
  };

  handleHome = () => {
    if (typeof window !== "undefined") {
      window.location.href = "/";
    }
  };

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div className="min-h-screen flex items-center justify-center bg-pearl p-6" data-testid="error-boundary">
        <div className="card-premium p-8 lg:p-10 max-w-lg text-center">
          <div className="w-16 h-16 mx-auto rounded-2xl bg-gradient-to-br from-amethyst-500 to-gold-500 flex items-center justify-center mb-5">
            <Sparkles className="w-7 h-7 text-white" strokeWidth={1.5} />
          </div>
          <h1 className="font-serif text-3xl font-medium text-amethyst-900">Something went wrong</h1>
          <p className="text-gray-600 mt-3">
            We hit an unexpected hiccup. Don't worry — your data is safe. Refresh to continue, or head back home.
          </p>
          {this.state.error?.message && (
            <p className="mt-4 text-xs text-gray-400 font-mono break-words">
              {String(this.state.error.message).slice(0, 200)}
            </p>
          )}
          <div className="mt-6 flex flex-col sm:flex-row gap-3 justify-center">
            <Button onClick={this.handleReset} className="btn-premium rounded-full px-6" data-testid="error-refresh-btn">
              <RefreshCw className="w-4 h-4 mr-2" /> Refresh page
            </Button>
            <Button onClick={this.handleHome} variant="outline" className="rounded-full px-6 border-amethyst-300 text-amethyst-700" data-testid="error-home-btn">
              Go to home
            </Button>
          </div>
        </div>
      </div>
    );
  }
}
